import {EzAppLayout, EzThemeProvider} from '@ezcater/recipe';
import Routes from './Routes';
import theme from './theme';
import './i18n';

const App = () => (
  <EzThemeProvider theme={theme}>
    <EzAppLayout>
      <Routes />
    </EzAppLayout>
  </EzThemeProvider>
);

export default App;
